// R-60 mood collections copy: drafted by Astra (copy lane, build/astra/copy-moods-prompt.md -> copy-moods.txt), gated by
// Claude 10/09/26 (all keys present, no dashes / exclamation marks / "listings" / AI words, subtitles at most 7 words).
// The seven names are Alvin's own (10/02). Do not edit by hand: a line that needs to change goes back to Astra.
export const MOODS: Record<string, string> = {
  "mood.title": "What sounds good?",
  "mood.move": "Get moving outside",
  "mood.move_sub": "Hikes, surfing, archery and group runs",
  "mood.chill": "Indoor and chill",
  "mood.chill_sub": "Quiet galleries, movies and board game cafes",
  "mood.make": "Make or do something",
  "mood.make_sub": "Pottery, painting, lessons and escape rooms",
  "mood.shop": "Browse and shop",
  "mood.shop_sub": "Farmers markets, flea markets and night markets",
  "mood.culture": "Museums and culture",
  "mood.culture_sub": "Museums, exhibits, historic houses and gardens",
  "mood.show": "See a show",
  "mood.show_sub": "Concerts, theater, comedy and film screenings",
  "mood.people": "Meet people",
  "mood.people_sub": "Meetups, run clubs and game nights",
  "mood.back": "Back to Browse",
  "mood.empty": "No activities match these filters. Try a wider area or more dates.",
}
export const mood = (key: string): string => MOODS[key] ?? key
